import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { PettyCashAction } from "../actions";
import * as PettyCashApi from "../api/pettyCash";
import { toastr } from "react-redux-toastr";
import { push, goBack } from "connected-react-router";
import { createBrowserHistory } from "history";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherPettyCash() {
  yield takeLatest(types.PETTY_CASH_GET_REQUEST, get);
  yield takeLatest(types.PETTY_CASH_STORE_REQUEST, store);
  yield takeLatest(types.PETTY_CASH_UPDATE_REQUEST, update);
  yield takeLatest(types.PETTY_CASH_DETAIL_REQUEST, detail);
  yield takeLatest(types.PETTY_CASH_LIST_REQUEST, list);
  yield takeLatest(types.PETTY_CASH_UPDATE_STATE_REQUEST, updateState);
  yield takeLatest(types.PETTY_CASH_REMOVE_REQUEST, remove);
}

async function fetchGet(id) {
  return PettyCashApi.get(id);
}

function* get(action) {
  try {
    const response = yield call(fetchGet, action.id);
    yield put(PettyCashAction.getRequestSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashAction.getRequestFailure());
  }
}

async function fetchDetail(id) {
  return PettyCashApi.getDetail(id);
}

function* detail(action) {
  try {
    const response = yield call(fetchDetail, action.id);
    yield put(PettyCashAction.getDetailSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashAction.getDetailFailure());
  }
}

async function fetchList(params) {
  return PettyCashApi.list(params);
}

function* list(action) {
  try {
    const response = yield call(fetchList, action.params);
    yield put(PettyCashAction.listSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashAction.listFailure());
  }
}

async function fetchStore(data) {
  return PettyCashApi.store(data);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data);
    yield put(PettyCashAction.storeSuccess());
    sessionStorage.removeItem("petty_cash_items");
    yield put(
      push({
        pathname: `/summary-pettycash/${response.data.data.id}`,
        state: { from: "/" }
      })
    );
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashAction.storeFailure());
  }
}

async function fetchUpdate(action) {
  return PettyCashApi.update(action.id, action.data);
}

function* update(action) {
  try {
    yield call(fetchUpdate, action);
    yield put(PettyCashAction.updateSuccess());
    sessionStorage.removeItem("petty_cash_items");
    yield put(goBack());
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashAction.updateFailure());
  }
}

async function fetchUpdateState(action) {
  return PettyCashApi.updateState(action.id, action.newState);
}

function* updateState(action) {
  try {
    const response = yield call(fetchUpdateState, action);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PettyCashAction.updateStateSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashAction.updateStateFailure());
  }
}

async function fetchRemove(id) {
  return PettyCashApi.remove(id);
}

function* remove(action) {
  const history = createBrowserHistory();
  try {
    const response = yield call(fetchRemove, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PettyCashAction.removeSuccess());
    if (action.goBack) {
      if (history.location.state && history.location.state.from) {
        yield put(push(history.location.state.from));
      } else {
        yield put(goBack());
      }
    }
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(PettyCashAction.removeFailure());
  }
}
